export default {
    namespaced: true,
    state: {
        googleApi: "AIzaSyC3nzNGZjB5UMOXKhlwIw_sIzZKsKAjedA"
    }
} 


// WEBPACK FOOTER //
// ./src/store/apiKeys.js